<template>
  <div>
    <h3 class="text-center">Prochains événements</h3>
    <b-list-group>
      <b-list-group-item v-for="event in events" :key="event.id" :to="'/evenement/'+event.id">
        <span>{{ event.date | moment("LLLL") }} - {{[event.end_time, "HH:mm:ss"] | moment("H:mm")}}</span>
        <span class="grey-text" v-if="new Date(event.date) > new Date()"> - Dans {{ event.date | moment("from", "now", true) }}</span><br>
        <span>Lieu : {{ event.location }}</span><br>
        <span v-if="event.theme">Thème : {{ event.theme }}</span><br>
        <i class="fas fa-chevron-right righticon"></i>
      </b-list-group-item>
      <b-list-group-item :to="'/evenements/'">
        <span>Voir tous les événements prévus</span>
        <i class="fas fa-chevron-right righticon"></i>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'Template',
  data: function(){
    return {
      events: '',
    }
  },
  created: function(){
    Vue.$backend.getNextEvents().then(res => this.events = res)
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.righticon{
  position: absolute;
  top: 45%;
  right: 10px;
}

.grey-text{
  color: grey;
  font-size: small;
}

</style>
